import { useCallback, useEffect, useState } from 'react'
import { SettingsModal } from './SettingsModal'
import { useQueryParams } from 'hooks/useQueryParams'
import { useHistory, useLocation } from 'react-router-dom'
import { Workspace } from 'types'
import { useModals } from 'almanac-ui/Modal'

interface Props {
  workspace?: Workspace
}

const SettingsContainer = ({ workspace }: Props) => {
  const history = useHistory()
  const location = useLocation()
  const { settings } = useQueryParams()
  const [isModalVisible, setIsModalVisible] = useState(false)
  const { openModal, closeModal } = useModals()

  const onClose = useCallback(() => {
    closeModal()
    const queryParams = new URLSearchParams(location.search)
    queryParams.delete('settings')
    queryParams.delete('provider')
    setTimeout(() => {
      history.push({ search: queryParams.toString() })
    }, 250)
  }, [history, location.search, closeModal])

  useEffect(() => {
    if (!workspace) return

    if (settings && !isModalVisible) {
      setIsModalVisible(true)
      openModal(SettingsModal, { workspace, onClose })
    }

    if (!settings && isModalVisible) {
      setIsModalVisible(false)
      closeModal()
    }
  }, [settings, isModalVisible, workspace, openModal, closeModal, onClose])

  return null
}

export default SettingsContainer
